const toggleState = (element: HTMLElement) => {
  const isExpanded = element.classList.toggle('expanded');

  if (!isExpanded) {
    element.scrollIntoView();
  }
};

const processCollapsibleTable = (table: HTMLDivElement) => {
  const btnMore = table.querySelector('.btn-show-more') as HTMLButtonElement;
  const btnLess = table.querySelector('.btn-show-less') as HTMLButtonElement;

  btnLess.addEventListener('click', () => {
    toggleState(table);
  });
  btnMore.addEventListener('click', () => {
    toggleState(table);
  });
};

function onDocumentReady(): void {
  document.querySelectorAll('.collapsible-table-container').forEach((table) => {
    processCollapsibleTable(table as HTMLDivElement);
  });
}

if (document.readyState !== 'loading') {
  onDocumentReady();
} else {
  document.addEventListener('DOMContentLoaded', onDocumentReady);
}
